<template>
  <canvas ref="chart" height="350"></canvas>
</template>
<script>
import { Chart } from 'chart.js'
export default {
  props: ['data', 'options'],
  data: () => {
    return { chart: null }
  },
  watch: {
    data: {
      handler(newData) {
        const canvas = this.$refs.chart
        const ctx = canvas.getContext('2d')
        this.chart.data = this.generateData(ctx, newData)
        this.chart.update()
      },
    },
  },

  mounted() {
    const canvas = this.$refs.chart
    const ctx = canvas.getContext('2d')

    this.chart = new Chart(ctx, {
      type: 'line',
      data: this.generateData(ctx, this.data),

      options: {
        maintainAspectRatio: false,
        ...(this.options || {}),

        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            padding: 7,
            caretSize: 8,
            bodyFont: {
              size: 20,
            },
            displayColors: false,
            xAlign: 'center',
            yAlign: 'bottom',
            callbacks: {
              title: function (_) {
                return null
              },
              label: function (context) {
                return context.dataset.tooltipLabels
                  ? context.dataset.tooltipLabels[context.dataIndex].split('|')
                  : context.formattedValue
              },
            },
          },
        },

        scales: {
          x: {
            ticks: {
              autoSkip: false,
              maxRotation: 90,
              minRotation: 0,
              font: {
                family: 'Source Sans Pro',
                size: 16,
                weight: 400,
              },
              color: '#333',
            },
            grid: {
              drawBorder: false,
              display: false,
              color: '#F5F5F5',
            },
          },
          y: {
            ticks: {
              stepSize: 5,
              font: {
                family: 'Source Sans Pro',
                size: 16,
                weight: 400,
              },
              color: '#333',
            },
            grid: { drawBorder: false, color: '#F5F5F5' },
          },
        },
      },
    })
  },
  methods: {
    generateData(ctx, data) {
      let gradient = ctx.createLinearGradient(0, 200, 0, 400)
      gradient.addColorStop(0.7, 'rgba(255,255,255, 0.3)')
      gradient.addColorStop(0, 'rgba(230,241,248,0.5)')

      return {
        ...data,
        datasets: this.data.datasets.map(set => ({
          borderColor: '#CEE4F2',
          pointBackgroundColor: '#004C8C',
          pointHoverBackgroundColor: '#004C8C',
          pointHoverRadius: 6,
          backgroundColor: gradient,
          fill: true,
          pointRadius: 0,
          pointHitRadius: 20,
          ...set,
        })),
      }
    },
  },
}
</script>
